import config from './config/news'
import axios from '@/utils/request'
export const newsList = params => axios.post(config.newsList, params)
export const newsDetail = params => axios.post(config.newsDetail, params)